export default "__VITE_ASSET__DaQXvUYp__"